export class HttpError<Payload = unknown> extends Error {
  status: number;

  constructor(
    public readonly response: Response,
    public readonly errorCode: number,
    public readonly payload: Payload,
    msg = `HTTP request failed with ${response.status}`,
  ) {
    super(msg);
    this.status = response.status;
  }
}

export async function createHttpError(res: Response, msg?: string) {
  if (res.headers.get("content-type")?.includes("application/json")) {
    const payload = (await res.json()) as any;
    return new HttpError(res, payload.error_code ?? 0, payload, msg);
  }

  return new HttpError(res, 0, undefined, msg);
}

export function isHttpError<Payload = unknown>(e: unknown): e is HttpError<Payload | undefined> {
  return e instanceof HttpError;
}
